import React, { useEffect } from 'react';
import styled from 'styled-components';
import top from 'assets/landing_top.svg';
import bottom from 'assets/landing_bottom.svg';
import KakaoShareButton from 'components/elements/KakaoShareButton';
import Button from 'components/elements/Button';

const MainWrapper = styled.div`
  text-align: center;
  .heading {
    padding-top: 32px;
  }
  .pic {
    height: 92px;
  }
  .desc {
    text-align: center;
    margin: 16px 0;
  }
  .sub {
    font-size: 18px;
    font-weight: 300;
    color: #2f2f2f;
    border-radius: 6px;
    background-color: #fff;
    display: inline-block;
    padding: 10px 15px;
    margin: 0 0 20px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  .btn-wrapper {
    margin-top: 10px;
    padding: 10px 20px;
    .cta {
      cursor: pointer;
      width: 100%;
      border: none;
      border-radius: 4px;
      height: 56px;
      color: rgba(0, 0, 0, 0.87);
      font-size: 16px;
      font-weight: 700;
    }
    .kakao-btn-wrapper {
      margin-top: 10px;
      button {
        width: 100%;
      }
    }
  }
`;

const Landing = ({ handleStart }) => {
  return (
    <>
      <MainWrapper>
        <div className="inner">
          <div className="heading">
            <img src={top} className="pic" alt="집콕 취미 찾기" />
            <h1 className="gana navy title">
              나도 몰랐던
              <br /> 나의 집콕 취미는?
            </h1>
            {/* <h4 className="gana sub">나 이거 좋아했네? 🤔</h4> */}
            <img src={bottom} className="pic" alt="집콕 취미 찾기" />
          </div>
          <div className="desc">
            심심한데 나갈 수는 없는 지금
            <br />
            새로운 취미를 시작할 기회일지도 몰라요!
          </div>
          <div className="btn-wrapper">
            <button onClick={handleStart} className="cta orange-bg">
              내 성향에 맞는 취미 찾기
            </button>
            <div className="kakao-btn-wrapper">
              <KakaoShareButton
                className="btn-lg"
                label={'테스트 공유하기'}
                url={'https://untacthobby.web.app'}
              />
            </div>
          </div>
        </div>
      </MainWrapper>
    </>
  );
};

export default Landing;
